<script setup>
const listeners = useListeners()
const props = defineProps({
  dark: [Boolean, Number],
  circle: Boolean,
  disable: [Boolean, Number],
  selected: Boolean,
  hover: Boolean,
  icon: String
})

const classMap = computed(() => ({
  'nio-button': true,
  'nio-dark': props.dark,
  'nio-circle': props.circle,
  'nio-disable': props.disable,
  'nio-selected': props.selected,
  'nio-hover': props.hover
}))
</script>

<template>
  <div
    :class="classMap"
    v-on="!disable && listeners"
  >
    <nio-icon :type="icon"/>
    <slot/>
  </div>
</template>

<style lang="scss" scoped>
.nio-button {
  @include flex-center(flex);
  @include transition;
  box-sizing: border-box;
  padding: 0 rem(20);
  height: rem(46);
  cursor: pointer;
  position: relative;
  font-size: 14px;

  &.nio-circle {
    display: inline-flex;
    width: rem(32);
    height: rem(32);
    padding: 0;
    border-radius: 50%;
  }

  // 正常状态hover
  // &:hover,
  &.nio-hover {
    color: #fff;
    background-color: #000;

    &::before {
      border-color: #000;
    }
  }

  // 用伪类实现边框，因为边框宽度会变化，影响内部布局
  &::before {
    content: '';
    display: block;
    pointer-events: none;
    border: 1px solid #818181;
    border-radius: inherit;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: inherit;
  }

  // 选中
  .nio-selected &,
  &.nio-selected {
    &::before {
      border: 2px solid #000;

      // 高清屏细一些
      @media (-webkit-min-device-pixel-ratio: 2) {   
        border-width: 1.5px;
      }
    }
  }

  // 深色模式
  .nio-dark &,
  &.nio-dark {
    color: #fff;

    // &:hover,
    &.nio-hover {
      color: #000;
      background-color: #fff;
    }

    &::before {
      border-color: #fff;
    }
  }

  // 禁用
  .nio-disable &,
  &.nio-disable {
    color: $color-l4 !important;
    background-color: transparent !important;

    &::before {
      border-color: $color-l4 !important;
    }

    // 深色模式下禁用
    .nio-dark &,
    &.nio-dark {
      color: rgba(255, 255, 255, 0.5) !important;

      &::before {
        border-color: rgba(255, 255, 255, 0.5) !important;
      }
    }
  }

  .nio-icon {
    width: rem(16);
    height: rem(16);
  }
}
</style>
